module.exports = __webpack_public_path__ + "static/media/title.53cdbc9e.png";